"use client";
import Badge from "@mui/material/Badge";

export const InProgressBadge = ({
  count,
  disabled,
  size,
  position,
  propsToBadge,
  children,
}: React.PropsWithChildren<{
  count: number;
  size?: "small";
  position?: { top?: string; right?: string; bottom?: string; left?: string };
  propsToBadge?: React.ComponentProps<typeof Badge>;
  disabled?: boolean;
}>) => {
  return (
    <Badge
      badgeContent={!disabled ? count : 0}
      showZero={false}
      color="error"
      overlap="circular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "& .MuiBadge-badge": {
          ...(size === "small" && {
            minWidth: "16px",
            height: "16px",
          }),
          ...position,
        },
        ...propsToBadge?.sx,
      }}
      {...propsToBadge}
    >
      {children}
    </Badge>
  );
};
